import React from "react";
import { file_type_options } from "../../../../../constants";

function FileTypeSelect(props) {
    const { name, label, onChange, value, options } = props;

    return (
        <div class="input-wrapper">
            <label htmlFor={name}>{label}</label>
            <select name={name} id={name} onChange={onChange}>
                <option value={""} selected={value == ""}>
                    None
                </option>
                {options.split(",").map((key) => (
                    <option value={key} selected={value == key}>
                        {file_type_options[key]}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default FileTypeSelect;
